import "./styles.css"
import { useEffect, useState } from "react";
import { IOptionsEvaluation } from "../../SystemManager/Monitoring/Tables/Index";
import TableVisualizationRowTask from "./TableVisualizationRow/Index";
import ViewTasks from "../../Tasks/ViewTasks";
import { Loading } from "../../Loading/Index";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/icons/rightChevron.svg"
import { useTableMonitor } from "../../../hooks/useTableMonitor";

interface TableProductsProps {
  listTable: ITaskEvaluation[];
  filter: IOptionsEvaluation | undefined;
  isLoading: boolean;
}

export default function TableTaskEvaluation({ listTable, isLoading }: TableProductsProps) {
  const [selectedId, setSelectedId] = useState(0);
  const { selectedOrder, setSelectedOrder, sortAsc, setSortAsc } = useTableMonitor();

  useEffect(() => {
    setSelectedOrder("createdAt")
  }, []);

  return (
    <>
      {listTable && listTable.length > 0 ?
        <>
          <table className="tableTaskEvaluation" style={{ minWidth: 1400 }} id="tableTaskEvaluation">
            <thead>
              <tr>
                {[
                  { key: "createdByUser.name", label: "Usuário" },
                  { key: "type", label: "Tarefa" },
                  { key: "microAreaInitials", label: "Pasto" },
                  { key: "batchInitials", label: "Lote" },
                  { key: "state", label: "Status" },
                  { key: "createdAt", label: <div>Data<br />Criação</div> },
                  { key: "updatedAt", label: <div>Data<br />Execução</div> },
                  { key: "syncedAt", label: <div>Data<br />Sincronização</div> },
                ].map(({ key, label }) => (
                  <th
                    key={key}
                    onClick={() => {
                      setSelectedOrder(key);
                      if (selectedOrder != key) {
                        setSortAsc(false)
                        return
                      };
                      setSortAsc(!sortAsc);
                    }}
                  >
                    <div className="infoColumn">
                      {label}
                      <ArrowIcon
                        className={`iconSort${sortAsc ? "--asc" : ""}`}
                        style={{
                          display: selectedOrder === key ? "block" : "none",
                        }}
                      />
                    </div>
                  </th>
                ))}
                <th />
              </tr>
            </thead>

            <tbody>
              {listTable.map(evaluation => (
                <TableVisualizationRowTask key={evaluation.id} evaluation={evaluation} setSelectedId={setSelectedId} />
              ))}
            </tbody>
          </table>
          
          {isLoading && (
            <div className="tableLoadingOverlay" style={{ minWidth: 1400 }}>
              <div className="lds-ring">
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </>
        :
        isLoading
          ?
          <div className="emptyTable_container">
            <Loading visible={true} />
          </div>
          :
          <div className="emptyTable_container">
            <span> Nenhum resultado encontrado.</span>
          </div>
      }

      <ViewTasks
        selected={selectedId}
        setSelectedId={setSelectedId}
      />
    </>
  )
}
